import React from "react";
import AudienceListItem from "../AudienceListItem/AudienceListItem";
import { Box, TextField, Typography } from "@tiny/components";
import { useStyles } from "./AudienceDestination.styles";
import CloseBig from "@tiny/icons/generated/CloseBig";
import { AudienceDestinationProps } from "./AudienceDestination.types";
import useAudienceDestination from "./AudienceDestination.hooks";

const AudienceDestination = (props: AudienceDestinationProps) => {
  const {
    destinationAudience,
    handleDragStart,
    handleDragEnd,
    handleDragOver,
    handleDrop,
    parentBoxRef,
    showSourceTextbox,
    setShowSourceTextbox,
    destinationAudienceName,
    setDestinationAudienceName,
  } = useAudienceDestination(props);

  const classes = useStyles();

  return destinationAudience ? (
    <Box
      ref={parentBoxRef}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
      key={destinationAudience.id}
      onDrop={handleDrop}
    >
      <AudienceListItem audience={destinationAudience} />
    </Box>
  ) : (
    <Box className={classes.noDestination}>
      {showSourceTextbox ? (
        <TextField
          className={classes.textField}
          autoFocus
          endIcon={
            <CloseBig
              onClick={() => {
                setDestinationAudienceName(undefined);
                setShowSourceTextbox(false);
              }}
            />
          }
          value={destinationAudienceName}
          onChange={(e) => setDestinationAudienceName(e.target.value)}
        />
      ) : (
        <Box
          className={classes.dropContainer}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onClick={() => setShowSourceTextbox(true)}
        >
          <Typography color="grey" tone={700} variant="label2">
            Drag from source or click here to create new
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default AudienceDestination;
